import React, {useState, useContext, useEffect} from "react";
import { useSnapshot } from 'valtio';
import state from "../store/index.js";

export const themeContext = React.createContext();
const themeToggleContext = React.createContext();

export function getThemeContext() {
    return useContext(themeContext);
}
export function getThemeToggleContext() {
    return useContext(themeToggleContext);
}

const ThemeProvider = ({ children }) =>{


    //Consiguiendo el tema que tenemos sea por el tema del navegador, o si está guardado en local storage.
    let themeInitial = null;
    const themeLocalStorage = localStorage.getItem("theme");
    let themeDetected = useThemeDetector();

    //Para elegir entre el tema guardado en local storage o el tema detectado por el navegador.
    if(themeLocalStorage === "dark" || themeLocalStorage === "light"){
        themeInitial = themeLocalStorage;
    }else if(themeDetected){
        themeInitial = themeDetected
    }

    //Inicializando las variables y seteando el html para que funcione el tema.
    const [theme, setTheme] = useState(themeInitial);
    localStorage.setItem("theme", themeInitial);
    document.getElementsByTagName("HTML")[0]
        .setAttribute("data-theme",themeInitial);
    document.getElementsByTagName("HTML")[0]
        .setAttribute("class",themeInitial);


    const snap = useSnapshot(state);

    const cambiaTheme = () => {
        if (theme === 'light') {
            localStorage.setItem("theme", "dark");
            document.getElementsByTagName("HTML")[0]
                .setAttribute("data-theme","dark")
            document.getElementsByTagName("HTML")[0]
                .setAttribute("class","dark");
            setTheme("dark");

            state.color = "#5e000c";
            state.backgroundColor = "#e8e8e8";


        } else {
            localStorage.setItem("theme", "light");
            document.getElementsByTagName("HTML")[0]
                .setAttribute("data-theme","light");
            document.getElementsByTagName("HTML")[0]
                .setAttribute("class","");
            setTheme("light");
            state.color = "#bdafb1";
            state.backgroundColor = "#2f020d";

        }

    }

    return (
        <themeContext.Provider value={theme}>
            <themeToggleContext.Provider value={cambiaTheme}>
                { children }
            </themeToggleContext.Provider>
        </themeContext.Provider>
    );
}



const useThemeDetector = () => {
    const getCurrentTheme = () => window.matchMedia("(prefers-color-scheme: dark)").matches;
    const [isDarkTheme, setIsDarkTheme] = useState(getCurrentTheme());
    const mqListener = (e => {
        setIsDarkTheme(e.matches);
    });

    useEffect(() => {
        const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)");
        darkThemeMq.addListener(mqListener);
        return () => darkThemeMq.removeListener(mqListener);
    }, []);
    return isDarkTheme ? "dark" : "light";
}



export default ThemeProvider;